import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Badge,
  Row,
  Col,
  Button,
  Card,
  Table,
  DropdownItem,
  DropdownMenu,
  UncontrolledCollapse,
  DropdownToggle,
  Dropdown,
  FormGroup,
  Input,
  Tooltip,
} from "reactstrap";
import ProfileAvatar from "../../../constants/Images/defaultAvatar-1.png";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { authHeader } from "../../../functions/CoreFunctions";
import { debounce } from "underscore";
import API from "../../../redux/actions/API";
import { AGENCY_LICENSE_REPORT } from "../../../constants/ApiPaths";
import { getAgencyId } from "../../common/CommonFunctions";
import Pagination from "react-js-pagination";
import moment from "moment";
import generatePDF from "./LicenseReportGenerte";
import { CSVLink } from "react-csv";
import { Info } from "../../common/Info";
import { Box, Tab, Tabs } from "@mui/material";

export default function LicenseReport() {
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [customerdropdownOpen, setcustomerdropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [licensReport, setlicensReport] = useState([]);
  const [customerlicensReport, setcustomerlicensReport] = useState([]);
  const [totalrecords, settotalrecords] = useState(0);
  const [customertotalrecords, setcustomertotalrecords] = useState(0);
  const [currentpage, setCurrentPage] = useState(0);
  const [customerCurrentpage, setCustomerCurrentPage] = useState(0);
  const [status, setstatus] = useState("");
  const [customerstatus, setcustomerstatus] = useState("");
  const [licenecetype, setlicenecetype] = useState("");
  const [customerlicenecetype, setcustomerlicenecetype] = useState("");
  const [data, setdata] = useState([]);
  const [customerdata, setcustomerdata] = useState([]);
    let rowperpage = 10;

  const [validFromDate, setvalidFromDate] = useState("");
  const [customervalidFromDate, setcustomervalidFromDate] = useState("");
  const [validToDate, setvalidToDate] = useState("");
  const [customervalidToDate, setcustomervalidToDate] = useState("");
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const customertoggle = () => {
    setcustomerdropdownOpen(!customerdropdownOpen);
  };
  const headers = [
    { label: "Name", key: "userName" },
    { label: "Email", key: "email" },
    // { label: "Plan Amount", key: "planAmount" },
    { label: "Valid From Date", key: "validFromDate" },
    { label: "Valid to Date", key: "validToDate" },
    { label: "Type of License", key: "typeofLicense" },
    { label: "License Issued Date", key: "licenseIssuedDate" },
    // { label: "license Status", key: "licenseStatus" },
    { label: "License Status", key: "licenseStatus" },
    { label: "License Url", key: "licenseUrl"},
    { label: "Plan Amount", key: "planAmount" },
    { label: "Pet License Number", key: "dogLicenseNumber"},
    { label: "Pet Name", key: "dogName"},
    { label: "Pet Color", key: "color"},
    { label: "Pet Breed", key: "breed"},
    { label: "Pet Gender", key: "gender"},
    { label: "Pet Image Url", key: "dogImageUrl"}
  ];

  let getAgencyLicenseReport = async (
    licenecetype,
    status,
    validFromDate,
    validToDate,
    currentpage
  ) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_LICENSE_REPORT,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        offset: currentpage,
        isKennelLicense: licenecetype,
        licenseStatus: status === "In progress" ? "Pending" : status,
        validFromDate: validFromDate,
        validToDate: validToDate,
        isAgencyLicense: 1
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setlicensReport(data);
        const value = data.map((data) => ({
          userName: data.userName,
          email: data.email,
          // planAmount: "$ " + data.planAmount,
          typeofLicense: data.typeofLicense,
          validFromDate: data.validFromDate,
          validToDate: data.validToDate,
          licenseIssuedDate: data.licenseIssuedDate,
          licenseStatus: data.licenseStatus,
          licenseUrl: data.licenseUrl,
          planAmount: "$ " + data.planAmount,
          dogLicenseNumber: data.dogLicenseNumber,
          dogName: data.dogName,
          color: data.color ? data.color : null,
          breed: data.breed,
          gender: data.gender,
          dogImageUrl: data.dogImageUrl,
        }));
        setdata(value);
        settotalrecords(totalCount);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
    let getCustomerLicenseReport = async (
    licenecetype,
    status,
    validFromDate,
    validToDate,
    currentpage
  ) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: AGENCY_LICENSE_REPORT,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        offset: currentpage,
        isKennelLicense: licenecetype,
        licenseStatus: status === "In progress" ? "Pending" : status,
        validFromDate: validFromDate,
        validToDate: validToDate,
        isAgencyLicense: 0
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setcustomerlicensReport(data);
        const value = data.map((data) => ({
          userName: data.userName,
          email: data.email,
          // planAmount: "$ " + data.planAmount,
          typeofLicense: data.typeofLicense,
          validFromDate: data.validFromDate,
          validToDate: data.validToDate,
          licenseIssuedDate: data.licenseIssuedDate,
          licenseStatus: data.licenseStatus,
          licenseUrl: data.licenseUrl,
          dogLicenseNumber: data.dogLicenseNumber,
          planAmount: "$ " + data.planAmount,
          dogName: data.dogName,
          color: data.color ? data.color : null,
          breed: data.breed,
          gender: data.gender,
          dogImageUrl: data.dogImageUrl,
        }));
        setcustomerdata(value);
        setcustomertotalrecords(totalCount);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };
const onCustomerPageChange = (page) => {
    setCustomerCurrentPage(page - 1);
  };
  let LicenseHandle = (e) => {
    setCurrentPage(0);
    setlicenecetype(e.target.value);
  };
  let CustomerLicenseHandle = (e) => {
    setCustomerCurrentPage(0);
    setcustomerlicenecetype(e.target.value);
  };
  let stateFiltreHandle = (e) => {
    setCurrentPage(0);

    setstatus(e.target.value);
  };
  let customerstateFiltreHandle = (e) => {
    setCustomerCurrentPage(0);

    setcustomerstatus(e.target.value);
  };
  let datefilterHandle = (e) => {
    setCurrentPage(0);
    setvalidFromDate(moment(e.target.value).format("MM/DD/YY"));
  };
 let customerdatefilterHandle = (e) => {
    setCustomerCurrentPage(0);
    setcustomervalidFromDate(moment(e.target.value).format("MM/DD/YY"));
  };
  let dateTofilterHandle = (e) => {
    setCurrentPage(0);
    setvalidToDate(moment(e.target.value).format("MM/DD/YY"));
  };
 let customerdateTofilterHandle = (e) => {
    setCustomerCurrentPage(0);
    setcustomervalidToDate(moment(e.target.value).format("MM/DD/YY"));
  };
  let Clear = () => {
    setlicenecetype("");
    setstatus("");
    setvalidFromDate("");
    setvalidToDate("");
  };
  let CustomerClear = () => {
    setcustomerlicenecetype("");
    setcustomerstatus("");
    setcustomervalidFromDate("");
    setcustomervalidToDate("");
  };
  let Export = () => {
    generatePDF(licensReport);
  };
  let CustomerExport = () => {
    generatePDF(customerlicensReport);
  };
  console.log("current", currentpage);
  const AgencySearch = useRef(
    debounce((licenecetype, status, validFromDate, validToDate, currentpage) =>
      getAgencyLicenseReport(
        licenecetype,
        status,
        validFromDate,
        validToDate,
        currentpage
      )
    )
  ).current;
 const CustomerSearch = useRef(
    debounce((customerlicenecetype, customerstatus, customervalidFromDate, customervalidToDate, customerCurrentpage) =>
      getCustomerLicenseReport(
        customerlicenecetype,
        customerstatus,
        customervalidFromDate,
        customervalidToDate,
        customerCurrentpage
      )
    )
  ).current;
  useEffect(() => {
    //callList();
    AgencySearch(licenecetype, status, validFromDate, validToDate, currentpage);
     CustomerSearch(customerlicenecetype, customerstatus, customervalidFromDate, customervalidToDate, customerCurrentpage);
  }, [licenecetype, status, validFromDate, validToDate, currentpage, customerlicenecetype, customerstatus, customervalidFromDate, customervalidToDate, customerCurrentpage]);

  // useEffect(() => {
  //   getAgencyLicenseReport();
  // }, [currentpage]);
const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    handleClick(newValue === 0 ? 'agency' : 'customer'); // Call your existing handler
  };

  const handleClick = (type) => {
    console.log(`Switched to ${type}`);
  };

  return (
    <div className="agency-wrapper">
      {loading && <CustomPageLoading />}

      <Container fluid>
        <div className="page-title">
          <Box sx={{ width: '100%' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
            aria-label="Agency and Customer Tabs"
            sx={{ gap: '2rem'}}
          >
            <Tab label="Agency License Report" sx={{ width: '300px', fontSize: '18px', fontWeight: '700', color: '#212529', textTransform: 'none'}} />
            <Tab label="Customer License Report" sx={{  width: '300px', fontSize: '18px', fontWeight: '700', color: '#212529', textTransform: 'none'}} />
          </Tabs>
          <Box sx={{ mt: 6 }}>
            {value === 0 && (
                <div>

          <div className="top-btn">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="danger" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={Export}>PDF</DropdownItem>
                <DropdownItem>
                  <CSVLink
                    filename={"License_report.csv"}
                    data={data}
                    headers={headers}
                  >
                    CSV
                  </CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Button id="toggler" color="link">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.371"
                height="14.371"
                viewBox="0 0 14.371 14.371"
              >
                <path
                  id="Icon_awesome-filter"
                  data-name="Icon awesome-filter"
                  d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                  fill="#1b3e6f"
                />
              </svg>
            </Button>
          </div>

        <div className="mt-4">
          <UncontrolledCollapse toggler="#toggler">
            <Card body>
              <Row className="mt-3">
                <Col md="3">
                  <FormGroup>
                    <span>Select License Type</span>
                    <Input
                      value={licenecetype}
                      onChange={LicenseHandle}
                      type="select"
                    >
                      <option value="">Select Licence Type</option>
                      <option value={true}> Kennel license </option>
                      <option value={false}>Licence </option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <span>Search From Date</span>
                    <Input
                      type="date"
                      placeholder="MM/DD/YYYY"
                      value={moment(validFromDate).format("YYYY-MM-DD")}
                      onChange={datefilterHandle}
                      name=""
                      id=""
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <span>Search To Date</span>
                    <Input
                      type="date"
                      placeholder="MM/DD/YYYY"
                      value={moment(validToDate).format("YYYY-MM-DD")}
                      onChange={dateTofilterHandle}
                      name=""
                      id=""
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <span>Select Status</span>
                    <Input
                      type="select"
                      name="stateId"
                      value={status}
                      onChange={stateFiltreHandle}
                      id=""
                      placeholder="Enter hyperlink"
                    >
                      <option value="">Select Status</option>
                      {[
                        "License Approved",
                        "Rejected",
                        "Payment Completed",
                        "License Generated",
                        "License Issued",
                        "Cancelled",
                        "In progress",
                        "Pay with Agency",
                      ].map((i) => (
                        <option key={i} value={i}>
                          {i}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="3">
                  <Button color="danger" onClick={Clear}>
                    Clear
                  </Button>
                </Col>
              </Row>
            </Card>
          </UncontrolledCollapse>
        </div>

        <Card body className="mt-4">
          <Table hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Plan Name</th>
                <th>Valid From</th>
                <th>Valid Till</th>
                <th>Type of License</th>
                <th>License Status</th>
                <th>License URL</th>
                <th>Plan Amount</th>
                <th>Dog License Number</th>
                <th>Pet Name</th>
                <th>Pet Color</th>
                <th>Pet Breed</th>
                <th>Pet Gender</th>
                <th>Pet Image Url</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                ""
              ) : (
                <>
                  {licensReport.length === 0 ? (
                    <tr>
                      <td colSpan={9}>
                        <center>No Record Found</center>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {licensReport.map((report, index) => (
                        <tr>
                          <td>
                            {" "}
                            <div className="user-box">
                              {report.profileImage === "" ? (
                                <img src={ProfileAvatar} alt="" />
                              ) : (
                                <img src={report.profileImage} alt=""/>
                              )}{" "}
                              {report.userName ? report.userName : "N/A"}
                            </div>
                          </td>
                          <td>{report.email ? report.email : "N/A"}</td>
                          <td>{report.planName ? report.planName : "N/A"}</td>
                          <td>
                            {report.validFromDate
                              ? report.validFromDate
                              : "N/A"}
                          </td>
                          <td>
                            {report.validToDate ? report.validToDate : "N/A"}
                          </td>
                          <td>
                            {report.typeofLicense
                              ? report.typeofLicense
                              : "N/A"}
                          </td>
                          <td>
                            {" "}
                            <Badge
                              className={
                                report.licenseStatus === "License Issued"
                                  ? "badge-pay-complete"
                                  : report.licenseStatus === "Pending"
                                  ? "badge-success-pen"
                                  : report.licenseStatus === "License Approved"
                                  ? "badge-success-apr"
                                  : report.licenseStatus === "Rejected"
                                  ? "badge-danger-soft"
                                  : report.licenseStatus === "Payment Completed"
                                  ? "badge-primary-soft"
                                  : report.licenseStatus === "License Generated"
                                  ? "badge-success-gen"
                                  : report.licenseStatus === "Cancelled"
                                  ? "badge-danger-soft"
                                  : ""
                              }
                            >
                              {report.licenseStatus === "Pending"
                                ? "In Progress"
                                : report.licenseStatus}
                            </Badge>{" "}
                          </td>
                          <td>{report.licenseUrl ? report.licenseUrl : "N/A"} </td>
                          <td> {report.planAmount ? '$ ' + report.planAmount: "N/A"} </td>
                          <td> {report.dogLicenseNumber ? report.dogLicenseNumber: "N/A"} </td>
                          <td> {report.dogName ? report.dogName : "N/A"}</td>
                          <td> {report.color ? report.color: "N/A"} </td>
                          <td> {report.breed ? report.breed: "N/A"} </td>
                          <td> {report.gender ? report.gender: "N/A"} </td>
                          <td> {report.dogImageUrl ? report.dogImageUrl: "N/A"} </td>
                        </tr>
                      ))}
                    </>
                  )}{" "}
                </>
              )}
            </tbody>
          </Table>
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              activePage={currentpage + 1}
              itemsCountPerPage={rowperpage}
              totalItemsCount={totalrecords}
              onChange={onPageChange}
            />
          </div>
        </Card>
                 </div>
            )}
            {value === 1 && (
                      <div>
                          <div className="top-btn">
            <Dropdown isOpen={customerdropdownOpen} toggle={customertoggle}>
              <DropdownToggle color="danger" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={CustomerExport}>PDF</DropdownItem>
                <DropdownItem>
                  <CSVLink
                    filename={"License_report.csv"}
                    data={customerdata}
                    headers={headers}
                  >
                    CSV
                  </CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Button id="toggler" color="link">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.371"
                height="14.371"
                viewBox="0 0 14.371 14.371"
              >
                <path
                  id="Icon_awesome-filter"
                  data-name="Icon awesome-filter"
                  d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                  fill="#1b3e6f"
                />
              </svg>
            </Button>
                     </div>
                    <div className="mt-4">
                  <UncontrolledCollapse toggler="#toggler">
                    <Card body>
                      <Row className="mt-3">
                        <Col md="3">
                          <FormGroup>
                            <span>Select License Type</span>
                            <Input
                              value={customerlicenecetype}
                              onChange={CustomerLicenseHandle}
                              type="select"
                            >
                              <option value="">Select Licence Type</option>
                              <option value={true}> Kennel license </option>
                              <option value={false}>Licence </option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <span>Search From Date</span>
                            <Input
                              type="date"
                              placeholder="MM/DD/YYYY"
                              value={moment(customervalidFromDate).format("YYYY-MM-DD")}
                              onChange={customerdatefilterHandle}
                              name=""
                              id=""
                            />
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <span>Search To Date</span>
                            <Input
                              type="date"
                              placeholder="MM/DD/YYYY"
                              value={moment(customervalidToDate).format("YYYY-MM-DD")}
                              onChange={customerdateTofilterHandle}
                              name=""
                              id=""
                            />
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <span>Select Status</span>
                            <Input
                              type="select"
                              name="stateId"
                              value={customerstatus}
                              onChange={customerstateFiltreHandle}
                              id=""
                              placeholder="Enter hyperlink"
                            >
                              <option value="">Select Status</option>
                              {[
                                "License Approved",
                                "Rejected",
                                "Payment Completed",
                                "License Generated",
                                "License Issued",
                                "Cancelled",
                                "In progress",
                              ].map((i) => (
                                <option key={i} value={i}>
                                  {i}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <Button color="danger" onClick={CustomerClear}>
                            Clear
                          </Button>
                        </Col>
                      </Row>
                    </Card>
                  </UncontrolledCollapse>
                </div>

                <Card body className="mt-4">
                  <Table hover responsive>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Plan Name</th>
                        <th>Valid From</th>
                        <th>Valid Till</th>
                        <th>Type of License</th>
                        <th>License Status</th>
                        <th>License URL</th>
                        <th>Plan Amount</th>
                        <th>Dog License Number</th>
                        <th>Pet Name</th>
                        <th>Pet Color</th>
                        <th>Pet Breed</th>
                        <th>Pet Gender</th>
                        <th>Pet Image Url</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        ""
                      ) : (
                        <>
                          {customerlicensReport.length === 0 ? (
                            <tr>
                              <td colSpan={9}>
                                <center>No Record Found</center>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {customerlicensReport.map((report, index) => (
                                <tr>
                                  <td>
                                    {" "}
                                    <div className="user-box">
                                      {report.profileImage === "" ? (
                                        <img src={ProfileAvatar} alt="" />
                                      ) : (
                                        <img src={report.profileImage} alt=""/>
                                      )}{" "}
                                      {report.userName ? report.userName : "N/A"}
                                    </div>
                                  </td>
                                  <td>{report.email ? report.email : "N/A"}</td>
                                  <td>{report.planName ? report.planName : "N/A"}</td>
                                  <td>
                                    {report.validFromDate
                                      ? report.validFromDate
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {report.validToDate ? report.validToDate : "N/A"}
                                  </td>
                                  <td>
                                    {report.typeofLicense
                                      ? report.typeofLicense
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {" "}
                                    <Badge
                                      className={
                                        report.licenseStatus === "License Issued"
                                          ? "badge-pay-complete"
                                          : report.licenseStatus === "Pending"
                                          ? "badge-success-pen"
                                          : report.licenseStatus === "License Approved"
                                          ? "badge-success-apr"
                                          : report.licenseStatus === "Rejected"
                                          ? "badge-danger-soft"
                                          : report.licenseStatus === "Payment Completed"
                                          ? "badge-primary-soft"
                                          : report.licenseStatus === "License Generated"
                                          ? "badge-success-gen"
                                          : report.licenseStatus === "Cancelled"
                                          ? "badge-danger-soft"
                                          : ""
                                      }
                                    >
                                      {report.licenseStatus === "Pending"
                                        ? "In Progress"
                                        : report.licenseStatus}
                                    </Badge>{" "}
                                  </td>
                                  <td>{report.licenseUrl ? report.licenseUrl : "N/A"} </td>
                                  <td> {report.planAmount ?  '$ ' + report.planAmount: "N/A"} </td>
                                  <td> {report.dogLicenseNumber ? report.dogLicenseNumber: "N/A"} </td>
                                  <td> {report.dogName ? report.dogName : "N/A"}</td>
                                  <td> {report.color ? report.color: "N/A"} </td>
                                  <td> {report.breed ? report.breed: "N/A"} </td>
                                  <td> {report.gender ? report.gender: "N/A"} </td>
                                  <td> {report.dogImageUrl ? report.dogImageUrl: "N/A"} </td>
                                </tr>
                              ))}
                            </>
                          )}{" "}
                        </>
                      )}
                    </tbody>
                  </Table>
                  <div className="d-flex flex-row py-4 justify-content-end">
                    <Pagination
                      itemClass="page-item"
                      linkClass="page-link"
                      activePage={customerCurrentpage + 1}
                      itemsCountPerPage={rowperpage}
                      totalItemsCount={customertotalrecords}
                      onChange={onCustomerPageChange}
                    />
                  </div>
                </Card>
                     </div>
            )}
  </Box>
     </Box>
      </div>
      </Container>
    </div>
  );
}
